/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("CanvasRectangleParametersVMBehavior", ["BehaviorBase"], function (context, cls) {
  /**
   * Behavior controlling the widget's Menu
   * @class CanvasRectangleParametersVMBehavior
   * @memberOf classes
   * @extends classes.BehaviorBase
   */
  cls.CanvasRectangleParametersVMBehavior = context.oo.Singleton(cls.BehaviorBase, function ($super) {
    return /** @lends classes.CanvasRectangleParametersVMBehavior.prototype */ {
      __name: "CanvasRectangleParametersVMBehavior",

      watchedAttributes: {
        anchor: ["startX", "startY", "endX", "endY"]
      },
      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        const node = controller.getAnchorNode();
        const startX = node.attribute("startX");
        const startY = node.attribute("startY");
        const endX = node.attribute("endX");
        const endY = node.attribute("endY");
        // Normalize
        const x = Math.min(startX, endX);
        const y = Math.min(startY, endY);
        const width = Math.abs(endX - startX);
        const height = Math.abs(endY - startY);
        controller.getWidget().setParameters(x, y, width, height);
      }
    };
  });
});
